import React, { Component } from 'react'

export default class VisiGiftActivateCampaign extends Component {
  render() {
    return (
      <div>VisiGiftActivateCampaign</div>
    )
  }
}
